<script>
import {defineComponent} from 'vue'
import img_1 from '@img/popular_banners/1.webp'
import img_2 from '@img/popular_banners/2.webp'
import img_3 from '@img/popular_banners/3.webp'
import PopularProductBannerItem
    from "@js/components/Sections/PageComponent/Home/Components/PopularProductBannerItem.vue";

export default defineComponent({
    name: "PopularBanners",
    components: {PopularProductBannerItem},
    setup() {
        return {img_1, img_2, img_3}
    }
})
</script>

<template>
    <div class="grid grid-cols-1 gap-5">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <div class="grid grid-cols-1">
                <PopularProductBannerItem title="Вывоз металлолома"
                                          description="Быстрый выезд транспорта, погрузка и расчёт на месте"
                                          :img="img_1"
                                          :link="route('deliveryAndShipping')"/>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <PopularProductBannerItem title="Демонтаж металлоконструкций"
                                          description="Профессиональный разбор зданий, ангаров и объектов"
                                          :img="img_2"
                                          :link="route('demontazhMetallokonstrukciy')"/>
                <PopularProductBannerItem title="Прием металла с выездом"
                                          description="Оценка, взвешивание и оплата на вашей территории"
                                          :img="img_3"
                                          :link="route('howToHandOver')"/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
</style>
